/** 회기를 만든 날짜·시각 (같은 회기를 두 번 만드는 실수를 줄이기 위해 목록에 작게 표시) */
export function createdLabel(iso: string): string {
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}.${d.getMonth() + 1}.${d.getDate()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function CreatedAt({ iso }: { iso: string }) {
  return <span className="created-at">만든 날 {createdLabel(iso)}</span>;
}
